import React from 'react';

const SectionHeader = ({ icon: Icon, title }) => (
  <div className="flex items-center gap-2 mb-4">
    <Icon className="h-5 w-5 text-gray-600" />
    <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
  </div>
);

export default SectionHeader;
